var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"temp-msg-container"},[(_vm.tempMsg)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.tempMsg)}}):_c('div',{staticClass:"msg-empty"},[_c('empty-box',{attrs:{"text":"消息过期啦"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }